export default function CssBaseline() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        'input[type=number]': {
          MozAppearance: 'textfield' as const,
        },
        'input[type=number]::-webkit-outer-spin-button, input[type=number]::-webkit-inner-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
      },
    },
  };
}
